var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "w-switch",
      class: [
        {
          on: _vm.on,
          focus: _vm.isFocused,
          disabled: _vm.disabled,
          required: _vm.required,
        },
      ].concat(_vm.inputFeedback.classes),
    },
    [
      _c(
        "a",
        {
          staticClass: "input-wrapper",
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.toggle.apply(null, arguments)
            },
          },
        },
        [
          _c("label", [
            _c("div", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))]),
          ]),
          _vm._m(0),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "control" }, [
      _c("div", { staticClass: "track" }),
      _c("div", { staticClass: "nob" }, [_c("div", { staticClass: "inner" })]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }